import { JSX, useCallback } from "react";

import MenuItem from "@mui/material/MenuItem";

export type SplitButtonOptionProps = {
	index: number;
	text: string;

	onClick: (option: number) => void;
};

export default function SplitButtonOption(
	props: Readonly<SplitButtonOptionProps>
): JSX.Element {
	const handleClick = useCallback(() => {
		props.onClick(props.index);
	}, [props.index, props.onClick]);

	return <MenuItem onClick={handleClick}>{props.text}</MenuItem>;
}
